import React from 'react';
import Header from 'components/Header';
import UIComponent from 'components/UiComponent';
import config from 'root/../config';
import proceduresConfig from '../../moduleConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane';
import AppContext from 'components/appContext';
import MsgBox from 'sis_ui/modules/notifications';
import { withRouter } from 'components/Routing';
import authService from 'services/authService';
import userService from 'services/userService';
import dataService from 'services/dataService';
import {withTranslation} from "react-i18next";

const sceneCode = "LOG_PROCEDURE_EVALUATIONS";

class LogProcedureEvaluations extends React.Component{

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            eval_type_id:null,
            isFocused:false,
        }

        this.setTriggerButtonActiveState = null;
        this.setEvaluationTypeValues = null;
    }

    componentWillMount(){
        this.context.setCurrentScene(sceneCode);
    }
    _triggerCallback(setError){
        return (result) =>{
            if (result.body) {
                result.body.MESSAGE.map((item, i) => {
                    if (item.TAG == "") {
                        if (item.TYPE != "success") MsgBox.drawMessage(item.TYPE,item.MESSAGE);
                    } else {
                        setError(item.TAG, item.MESSAGE);
                    }
                });
                if (result.body.STATUS == "success") {
                    MsgBox.drawMessage(result.body.STATUS,this.props.t('lbl.EVALUATION_CREATED_SUCCESSFULLY','Evaluation created successfully!'));
                    this.setEvaluationTypeValues([]);
                    this.callbackEvals = dataService.request({
                        method: 'POST',
                        url: config.apiAppUrl + proceduresConfig.APIs.triggerCallbackEvaluation,
                        query: result.body.DATA
                    }).accept('application/json');
                    this.callbackEvals.then((res) => {
                        try {
                            this.props.router.navigate('/' + proceduresConfig.map.PROCEDURE_EVALUATION_FORM.path + '/' +  res.body.DATA.USER_FORM_CD);
                        }
                        catch (e) {
                            MsgBox.drawMessage('error', this.props.t('lbl.INVALID_RESPONSE','Invalid response format'))
                        }
                    });
                }
            } else {
                MsgBox.drawMessage('error',this.props.t('lbl.INVALID_RESPONSE','Invalid response format'));
            }
            if (this.setTriggerButtonActiveState) this.setTriggerButtonActiveState('active');
        }
    }

    render() {
        return (
            <div className="trigger-evaluations-scene full-height--with-policy flex-column row">
                <Header {...this.props} />
                <UIComponent 
                    component="smart-form"
                    name="trigger-eval"
                    class="trigger-eval"
                    values={{
                        auth_token: authService.getToken(),
                        user_role: userService.getUserRole(),
                    }}
                    outReducer={(accumulator, value)=>{
                        let val = value[1] ? value[1] : "";
                        if (Array.isArray(val)) {
                            val = val.join(',');
                        }
                        return {
                            ...accumulator,
                            [value[0]]: val,
                        }
                    }}
                >           
                    <div className="pt-3">
                        <UIComponent component="smart-form-consumer">
                            {({values, setValue, submitForm, setValues, setError, setErrors, errors}) => {
                                return <div className="col" style={{marginBottom: "4em"}}>                                
                                    <UIComponent
                                        component="multiselect"
                                        name={"eval_type_id"}
                                        id={"eval_type_id"}
                                        url={config.apiAppUrl + proceduresConfig.APIs.getEvaluationType}
                                        urlParams={{
                                            auth_token: authService.getToken(),
                                            user_role: userService.getUserRole(),
                                        }}
                                        onChange={(elementValue) => {
                                            this.setState({eval_type_id:elementValue.VALUE[0]})
                                            setValue("eval_type_id", null);
                                            setValue("entityCode", null);
                                            setErrors({});
                                            setValue("eval_type_id", elementValue.VALUE[0]);
                                            setValue("entityCode", elementValue.META && elementValue.META.length ? elementValue.META[0].EVAL_ENTITY : null);
                                        }}
                                        keyField="EVAL_TYPE_ID"
                                        descField="EVAL_TYPE_NAME"
                                        metadataFields="EVAL_ENTITY"
                                        single
                                        showCloseFilterButton
                                        fetchMethod="GET"
                                        //afterInit={(metadata)=>{this._setFormValue(metadata['selectValueData'], metadata.id, setValue)}}
                                        naDesc={this.props.t("lbl.EVALUATION_TYPE","Evaluation Type")}
                                        label={this.props.t("lbl.EVALUATION_TYPE","Evaluation Type")}
                                        title={this.props.t("lbl.EVALUATION_TYPE","Evaluation Type")}
                                        showTitleBar
                                        getPublicData={({setValues}) =>{
                                            this.setEvaluationTypeValues = setValues;
                                        }}
                                        tabIndexContainer = {".dropdown-menu"}
                                    />
                                    {values.hasOwnProperty("entityCode") && values["entityCode"] ? 
                                        <React.Fragment>
                                            <UIComponent 
                                                component="entity-render"
                                                id="trigger-new-eval-entity"
                                                entityCode={values["entityCode"]}
                                                apiEntryPoint={config.apiAppUrl}
                                                errors={errors}
                                                params={{
                                                    auth_token: authService.getToken(),
                                                    user_role: userService.getUserRole(),
                                                    trainee_id: this.context.userDetails.CURRENT_ROLE == "TRAINEE" ? this.context.userDetails.USER_ID : -1,
                                                    supervisor_id: this.context.userDetails.CURRENT_ROLE == "SUPERVISOR" ? this.context.userDetails.USER_ID : -1,
                                                }}
                                                onChange={(entityFormValues)=>{
                                                    setValues({
                                                        ...entityFormValues,
                                                        eval_type_id:this.state.eval_type_id
                                                    });
                                                }}
                                                htmlForm={false}
                                                placeholder={
                                                    <div>
                                                        <div className="text-mock__full bg-primary-placeholder shine mb-5"></div>
                                                        <div className="text-mock__full bg-primary-placeholder shine mb-5"></div>
                                                        <div className="text-mock__full bg-primary-placeholder shine mb-5"></div>
                                                    </div>
                                                }
                                                renderOptions={{
                                                    SUPERVISOR_NAME: {
                                                        disabled: userService.getUserRole() == "SUPERVISOR" ? true :  undefined,
                                                    }
                                                }}
                                                tabIndexContainer = {".dropdown-menu"}
                                                treeTabIndexContainer = {".tree-dropdown"}
                                            />

                                            <UIComponent
                                                component="smart-button"
                                                id="logBtn"
                                                name="logBtn"
                                                class={`btn-fab color-white bg-green ${this.state.isFocused ? 'focus-border' : ''}`}
                                                style={{ right: '1em', bottom: '1em' }}
                                                title={this.props.t("lbl.LOG","Log")}
                                                iconComponent={<FontAwesomeIcon icon={faPaperPlane} size={"1x"} />}
                                                triggeredText={this.props.t("lbl.LOGGING","Logging...")}
                                                onClick={(event, setActiveState) => {
                                                    event.preventDefault();
                                                    this.setTriggerButtonActiveState = setActiveState;
                                                    submitForm({ action: config.apiAppUrl + proceduresConfig.APIs.triggerEvaluation, method: "POST" }, this._triggerCallback(setError, setValue).bind(this));
                                                }}
                                                onFocus={() => {
                                                    this.setState({ isFocused: true })
                                                }}
                                                onBlur={() => {
                                                    this.setState({ isFocused: false })
                                                }}
                                            > {this.props.t("lbl.LOG","Log")} </UIComponent>
                                        </React.Fragment>
                                    : null}

                                </div>
                            }}
                        </UIComponent>
                    </div>
                </UIComponent>
            </div>

        )
    }
}

const TriggerWithRouter = withRouter(withTranslation()(LogProcedureEvaluations));
export default TriggerWithRouter;
LogProcedureEvaluations.contextType = AppContext;